@if (isDefault) {
<fa-icon
  class="text-primary paste-icon animation"
  [icon]="['fas', 'thumbtack']"
></fa-icon>
}
